import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 * @deprecated since version 8.1.0
 * @tdr-deprecated-date: 2022-04-11
 */
export default svgIcon(React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64" },
    React.createElement("path", { fill: "currentColor", d: "M24.38,38.94V44c0,.25.06,6.25,5.16,7.53A5,5,0,0,0,34,51a3.7,3.7,0,0,0,1.36-2.78V38.48l1.94-.93V40h14V12.75h-14v2.54l-2.79-2H12.7V38.94ZM39.75,15.25h9V37.51h-9Zm-24.55.54H33.65l3.55,2.54V34.8l-4.39,2.11V48.2a1.25,1.25,0,0,1-.41.84,2.87,2.87,0,0,1-2.25.07c-3.2-.8-3.26-4.93-3.27-5.1V36.44H15.2Z" })), 'ThumbsDown');
//# sourceMappingURL=ThumbsDown.js.map